import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import "../../styles/forgot_password.css";
import _ from "lodash/fp";
import ForgotPasswordJson from "../labels/forgot_password_en.json";
import { emailRegex, mobileRegex } from "../../common/constants/regex";
import { useForm } from "react-hook-form";
import {
  generateOTPForgotPassword,
  verificationOfOTP,
  enableOTPButton,
} from "../../common/actions/commonActions";
import { resetPassword } from "../actions/forgotPasswordAction";

function ForgotPassword(props) {
  const { register, handleSubmit, watch, errors, setError, formState } =
    useForm({
      mode: "onChange",
    });
  const verifyOTPFlag = useSelector(
    (state) => state.common.verifyOTPFlagForgotPassword
  );
  const dispatch = useDispatch();
  let { emailOTPResponse, mobileOTPResponse, otpDataEmail, otpDataMobile } =
    useSelector((state) => state.common, shallowEqual);
  let otpIdResponse = "";
  let otpTypeResponse = "";
  const [confirmPasswordFlag, setConfirmPasswordFlag] = useState(false);
  const [getOTPdisabled, setgetOTPdisabled] = useState(false);
  const [selectedtype, setSelectedType] = useState();

  useEffect(() => {
    startTime(selectedtype);
  }, [otpDataEmail, selectedtype]);

  useEffect(() => {
    startTime(selectedtype);
  }, [otpDataMobile, selectedtype]);

  const startEmailTimer = parseInt(otpDataEmail[0]?.expiryDuration);
  const startMobileTimer = parseInt(otpDataMobile[0]?.expiryDuration);
  const startTime = (otpType) => {
    if (otpType === "emailId") {
      let start = startEmailTimer;

      function displayTime() {
        let end = start - 1;
        start = end;
        let element = document.getElementById("emailTimer");
        if (element) {
          element.textContent = start;
        }
        if (start === 0) {
          clearInterval(createClock);
          setgetOTPdisabled(false);
        }
      }
      const createClock = setInterval(displayTime, 1000);
    }
    if (otpType === "mobileNo") {
      let start = startMobileTimer;

      function displayTime() {
        let end = start - 1;
        start = end;
        let element = document.getElementById("mobTimer");
        if (element) {
          element.textContent = start;
        }
        if (start === 0) {
          clearInterval(createClock);
          setgetOTPdisabled(false);
        }
      }
      const createClock = setInterval(displayTime, 1000);
    }
  };

  const checkValidity = (evt) => {
    if (evt.target.value === watch("password")) {
      setConfirmPasswordFlag(false);
    } else {
      setConfirmPasswordFlag(true);
    }
  };
  const getOTP = (otpType) => {
    if (watch("emailId")) {
      dispatch(
        generateOTPForgotPassword({
          email: watch("emailId").trim(),
          mobile: "",
          type: "email",
          otpFor: "frgtpass",
          isForgotPassword: true,
          sendOtpTo: "email",
          sendOtpDifferent: true,
        })
      );
      setgetOTPdisabled(true);
      setSelectedType(otpType);
    } else if (watch("mobileNo")) {
      dispatch(
        generateOTPForgotPassword({
          email: "",
          mobile: watch("mobileNo").trim(),
          type: "mobile",
          otpFor: "frgtpass",
          isForgotPassword: true,
          sendOtpTo: "mobile",
          sendOtpDifferent: true,
        })
      );
      setgetOTPdisabled(true);
      setSelectedType(otpType);
    } else {
      setError(otpType.toString(), { type: "required" });
    }
  };

  const verificationOTP = () => {
    if (watch("OTP_email")) {
      if (emailOTPResponse.id !== "" && emailOTPResponse.type !== "") {
        otpIdResponse = emailOTPResponse.id;
        otpTypeResponse = emailOTPResponse.type;
      }
      if (mobileOTPResponse.id !== "" && mobileOTPResponse.type !== "") {
        otpIdResponse = mobileOTPResponse.id;
        otpTypeResponse = mobileOTPResponse.type;
      }
      let userName;
      if (watch("usertype") === "mobile") {
        userName = watch("mobileNo");
      } else if (watch("usertype") === "email") {
        userName = watch("emailId");
      }

      let reqBody = {
        username: userName.trim(),
        otpId: otpIdResponse,
        otpType: otpTypeResponse,
        enteredOtp: watch("OTP_email"),
      };
      dispatch(verificationOfOTP(reqBody, "forgotPassword"));
    }
  };

  const reDirectToLogIn = () => {
    props.history.push("/admin/login");
    dispatch(enableOTPButton("login"));
  };

  const onSubmit = (data, e) => {
    let userName;
    let emailOtpId;

    if (watch("usertype") === "mobile") {
      userName = watch("mobileNo");
    } else if (watch("usertype") === "email") {
      userName = watch("emailId");
    }
    if (emailOTPResponse.id !== "" && emailOTPResponse.type !== "") {
      emailOtpId = emailOTPResponse.id;
    }
    if (mobileOTPResponse.id !== "" && mobileOTPResponse.type !== "") {
      emailOtpId = mobileOTPResponse.id;
    }

    if (!confirmPasswordFlag) {
      let reqBody = {
        email: userName,
        password: data.password,
        emailOtpId: emailOtpId,
        enteredEmailOtp: watch("OTP_email"),
        type: data.usertype,
      };
      dispatch(resetPassword(reqBody, props));
    }
    dispatch(enableOTPButton("login"));
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="row marginTop50p marginBottom100p"
      >
        <div className="col-md-3"></div>
        <div className="col-md-6 bgcolor-white p-30 pl-100 pr-100">
          <div className="text-center">
            <span className="bold-text">
              {ForgotPasswordJson.Forgot_Password_TITLE}
            </span>
          </div>
          <div className="row">
            <div className="col-md-12 text-center m-10">
              <label className="pos-relative tp-12 rt-30 mr-10">
                <input
                  type="radio"
                  className="radio"
                  name="usertype"
                  value="email"
                  ref={register({ required: false })}
                />
                &nbsp;{ForgotPasswordJson.Email_ID}
              </label>
              <label className="pos-relative tp-12 rt-30 mr-10">
                <input
                  type="radio"
                  className="radio"
                  name="usertype"
                  value="mobile"
                  ref={register({ required: false })}
                />
                &nbsp;{ForgotPasswordJson.Mobile_Number}
              </label>
            </div>
          </div>
          {watch("usertype") === "email" ? (
            <div>
              <label className="LeftText">
                {ForgotPasswordJson.Email_ID}
                <span className="errorText">*</span>
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  id="registrationFormControlInput1"
                  type="text"
                  name="emailId"
                  ref={register({ required: true, pattern: emailRegex })}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-secondary font-12 pl-22"
                    type="button"
                    id="button-addon2"
                    onClick={() => getOTP("emailId")}
                    disabled={
                      getOTPdisabled ||
                      _.get("emailId.type", errors) === "pattern"
                    }
                  >
                    Get OTP
                  </button>
                </div>
              </div>
              {_.get("emailId.type", errors) === "required" && (
                <p className="errorText">
                  {ForgotPasswordJson.validationMessage.ONLY_EMAIL_REQUIRED}
                </p>
              )}
              {_.get("emailId.type", errors) === "pattern" && (
                <p className="errorText">
                  {ForgotPasswordJson.validationMessage.EMAIL_PATTERN}
                </p>
              )}
              {getOTPdisabled && verifyOTPFlag === false ? (
                <p className="Note-color font-11">
                  {ForgotPasswordJson.New_OTP_will_generated}{" "}
                  <span id="emailTimer"></span> {ForgotPasswordJson.seconds}.
                </p>
              ) : (
                <p className="Note d-none">
                  {ForgotPasswordJson.New_OTP_will_generated}{" "}
                  <span id="emailTimer"></span> {ForgotPasswordJson.seconds}.
                </p>
              )}
            </div>
          ) : (
            ""
          )}
          {watch("usertype") === "mobile" ? (
            <div>
              <label className="LeftText">
                {ForgotPasswordJson.Mobile_Number}
                <span className="errorText">*</span>
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  id="registrationFormControlInput1"
                  type="text"
                  name="mobileNo"
                  ref={register({ required: true, pattern: mobileRegex })}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-secondary font-12 pl-22"
                    type="button"
                    id="button-addon2"
                    onClick={() => getOTP("mobileNo")}
                    disabled={
                      getOTPdisabled ||
                      _.get("mobileNo.type", errors) === "pattern"
                    }
                  >
                    {ForgotPasswordJson.Get_OTP}
                  </button>
                </div>
              </div>
              {_.get("mobileNo.type", errors) === "required" && (
                <p className="errorText">
                  {ForgotPasswordJson.validationMessage.MOBILE_REQ}
                </p>
              )}
              {_.get("mobileNo.type", errors) === "pattern" && (
                <p className="errorText">
                  {ForgotPasswordJson.validationMessage.MOBILE_PATTERN}
                </p>
              )}
              {getOTPdisabled && verifyOTPFlag === false ? (
                <p className="Note-color font-11">
                  {ForgotPasswordJson.New_OTP_will_generated}{" "}
                  <span id="mobTimer"></span> {ForgotPasswordJson.seconds}.
                </p>
              ) : (
                <p className="Note d-none">
                  {ForgotPasswordJson.New_OTP_will_generated}{" "}
                  <span id="mobTimer"></span> {ForgotPasswordJson.seconds}.
                </p>
              )}
            </div>
          ) : (
            ""
          )}
          <div>
            {watch("usertype") === "email" ? (
              <div>
                <label className="LeftText">
                  {ForgotPasswordJson.EMAIL_INPUT_LABEL}
                  <span className="errorText">*</span>
                </label>
              </div>
            ) : (
              ""
            )}
            {watch("usertype") === "mobile" ? (
              <div>
                <label className="LeftText">
                  {ForgotPasswordJson.MOBILE_INPUT_LABEL}
                  <span className="errorText">*</span>
                </label>
              </div>
            ) : (
              ""
            )}
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder=""
                maxLength={6}
                name="OTP_email"
                id="OTP_email"
                ref={register({ required: true })}
                aria-label="emailotp"
                aria-describedby="button-addon2"
                disabled={verifyOTPFlag}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-secondary font-12"
                  type="button"
                  id="button-addon2"
                  onClick={() => {
                    verificationOTP();
                  }}
                  disabled={verifyOTPFlag}
                >
                  {ForgotPasswordJson.Verify_OTP}
                </button>
              </div>
            </div>
            {_.get("OTP_email.type", errors) === "required" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.OTP_REQ}
              </p>
            )}
          </div>
          <div>
            <label className="LeftText">
              {ForgotPasswordJson.Password}
              <span className="errorText">*</span>
            </label>
            <input
              className="form-control"
              id="registrationFormControlInput2"
              type="password"
              name="password"
              onChange={checkValidity}
              disabled={!verifyOTPFlag}
              ref={register({
                required: true,
                minLength: 8,
                maxLength: 15,
                validate: {
                  oneCapitalLetter: (value) =>
                    /(?![.\n])(?=.*[A-Z]).*$/.test(value),
                  oneNumber: (value) => /((?=.*\d)|(?=.*\W+)).*$/.test(value),
                  oneSpecialCharacter: (value) =>
                    /(?=.*[!@#=%=&=])(?=.{8,}$)/.test(value),
                },
              })}
            />
            {_.get("password.type", errors) === "required" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.PASSWORD_REQ}
              </p>
            )}
            {_.get("password.type", errors) === "minLength" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.MIN_LENGTH_VALIDATION}
              </p>
            )}
            {_.get("password.type", errors) === "maxLength" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.MAX_LENGTH_VALIDATION}
              </p>
            )}
            {errors.password?.type === "oneCapitalLetter" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.MIN_ONE_CAPITAL_LETTER}
              </p>
            )}
            {errors.password?.type === "oneNumber" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.MIN_ONE_NUMBER}
              </p>
            )}
            {errors.password?.type === "oneSpecialCharacter" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.MIN_ONE_SPECIAL_CHAR}
              </p>
            )}
            {errors.password && (
              <p className="errorText">{errors.password.message}</p>
            )}
          </div>
          <div>
            <label className="LeftText">
              {ForgotPasswordJson.Confirm_Password}
              <span className="errorText">*</span>
            </label>

            <input
              className="form-control"
              id="registrationFormControlInput2"
              type="password"
              name="confirm_password"
              ref={register({ required: true })}
              onChange={checkValidity}
              disabled={!verifyOTPFlag}
            />
            {_.get("confirm_password.type", errors) === "required" && (
              <p className="errorText">
                {ForgotPasswordJson.validationMessage.CONFIRM_PASSWORD_REQUIRED}
              </p>
            )}
            {confirmPasswordFlag &&
            _.get("confirm_password.type", errors) !== "required" ? (
              <p className="errorText">
                {ForgotPasswordJson.New_password_Confirm_password_same}
              </p>
            ) : (
              ""
            )}
          </div>
          <br></br>
          <div className="buttonAlign">
            <button
              type="submit"
              className="btn btn-primary mr-5"
              disabled={!formState.isValid}
            >
              {ForgotPasswordJson.Save}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={reDirectToLogIn}
            >
              {ForgotPasswordJson.CANCEL}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
export default ForgotPassword;
